'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Hackle = require('@hackler/javascript-sdk');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var Hackle__namespace = /*#__PURE__*/_interopNamespace(Hackle);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

var SDK_NAME_HEADER = "react-sdk";
var SDK_VERSION_HEADER = "11.34.2" ;

var Emitter = /** @class */ (function () {
    function Emitter() {
        this.listeners = {};
    }
    Emitter.prototype.on = function (eventName, fn) {
        this.listeners[eventName] = (this.listeners[eventName] || []).concat(fn);
    };
    Emitter.prototype.off = function (eventName, fn) {
        this.listeners[eventName] = (this.listeners[eventName] || []).filter(function (f) { return f !== fn; });
    };
    Emitter.prototype.emit = function (eventName, params) {
        (this.listeners[eventName] || []).forEach(function (fn) {
            fn(params);
        });
    };
    return Emitter;
}());

var ObjectUtil = /** @class */ (function () {
    function ObjectUtil() {
    }
    ObjectUtil.arePropertiesEqual = function (prevProps, currentProps) {
        var prev = ObjectUtil.coerceUnknownToProperties(prevProps);
        var current = ObjectUtil.coerceUnknownToProperties(currentProps);
        var prevKeys = Object.keys(prev);
        var currentKeys = Object.keys(current);
        if (prevKeys.length !== currentKeys.length) {
            return false;
        }
        return prevKeys.every(function (it) {
            // @ts-ignore
            return it in current && prev[it] === current[it];
        });
    };
    ObjectUtil.coerceUnknownToProperties = function (props) {
        if (typeof props === "object" && props !== null) {
            return props;
        }
        return {};
    };
    return ObjectUtil;
}());
var UserUtil = /** @class */ (function () {
    function UserUtil() {
    }
    UserUtil.isUserEqual = function (prevUser, currentUser) {
        return ((prevUser === null || prevUser === void 0 ? void 0 : prevUser.id) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) &&
            (prevUser === null || prevUser === void 0 ? void 0 : prevUser.deviceId) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.deviceId) &&
            (prevUser === null || prevUser === void 0 ? void 0 : prevUser.userId) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId) &&
            ObjectUtil.arePropertiesEqual(prevUser === null || prevUser === void 0 ? void 0 : prevUser.properties, currentUser === null || currentUser === void 0 ? void 0 : currentUser.properties) &&
            ObjectUtil.arePropertiesEqual(prevUser === null || prevUser === void 0 ? void 0 : prevUser.identifiers, currentUser === null || currentUser === void 0 ? void 0 : currentUser.identifiers));
    };
    return UserUtil;
}());

var HackleReactSDKClient = /** @class */ (function (_super) {
    __extends(HackleReactSDKClient, _super);
    function HackleReactSDKClient(sdkKey, config) {
        var _this = _super.call(this) || this;
        _this._currentUser = null;
        _this.client = Hackle__namespace.createInstance(sdkKey, __assign(__assign({}, config), { SDK_NAME_HEADER: SDK_NAME_HEADER, SDK_VERSION_HEADER: SDK_VERSION_HEADER }));
        // This is to prevent the "This Binding" problem.
        _this.getUser = _this.getUser.bind(_this);
        _this.setUser = _this.setUser.bind(_this);
        _this.setUserId = _this.setUserId.bind(_this);
        _this.setDeviceId = _this.setDeviceId.bind(_this);
        _this.setUserProperty = _this.setUserProperty.bind(_this);
        _this.updateUserProperties = _this.updateUserProperties.bind(_this);
        _this.resetUser = _this.resetUser.bind(_this);
        _this.variation = _this.variation.bind(_this);
        _this.variationDetail = _this.variationDetail.bind(_this);
        _this.isFeatureOn = _this.isFeatureOn.bind(_this);
        _this.featureFlagDetail = _this.featureFlagDetail.bind(_this);
        _this.track = _this.track.bind(_this);
        _this.trackPageView = _this.trackPageView.bind(_this);
        _this.remoteConfig = _this.remoteConfig.bind(_this);
        _this.onReady = _this.onReady.bind(_this);
        _this.onInitialized = _this.onInitialized.bind(_this);
        _this.emitUpdatedUser = _this.emitUpdatedUser.bind(_this);
        _this.showUserExplorer = _this.showUserExplorer.bind(_this);
        _this.hideUserExplorer = _this.hideUserExplorer.bind(_this);
        _this.fetch = _this.fetch.bind(_this);
        if ((config === null || config === void 0 ? void 0 : config.devTool) && (config === null || config === void 0 ? void 0 : config.autoOpenDevTool) && typeof window !== "undefined") {
            _this.showUserExplorer();
        }
        return _this;
    }
    HackleReactSDKClient.prototype.getUser = function () {
        return this.client.getUser();
    };
    HackleReactSDKClient.prototype.setUser = function (user) {
        this.client.setUser(user);
        this.emitUpdatedUser(this.getUser());
    };
    HackleReactSDKClient.prototype.setUserId = function (userId) {
        this.client.setUserId(userId);
        this.emitUpdatedUser(this.getUser());
    };
    HackleReactSDKClient.prototype.setDeviceId = function (deviceId) {
        this.client.setDeviceId(deviceId);
        this.emitUpdatedUser(this.getUser());
    };
    HackleReactSDKClient.prototype.setUserProperty = function (key, value) {
        this.client.setUserProperty(key, value);
        this.emitUpdatedUser(this.getUser());
    };
    HackleReactSDKClient.prototype.updateUserProperties = function (operations) {
        this.client.updateUserProperties(operations);
        this.emitUpdatedUser(this.getUser());
    };
    HackleReactSDKClient.prototype.resetUser = function () {
        this.client.resetUser();
        this.emitUpdatedUser(this.getUser());
    };
    HackleReactSDKClient.prototype.variation = function (experimentKey, user, defaultVariation) {
        return this.client.variation(experimentKey, user || undefined, defaultVariation);
    };
    HackleReactSDKClient.prototype.variationDetail = function (experimentKey, user, defaultVariation) {
        return this.client.variationDetail(experimentKey, user || undefined, defaultVariation);
    };
    HackleReactSDKClient.prototype.isFeatureOn = function (featureKey, user) {
        return this.client.isFeatureOn(featureKey, user || undefined);
    };
    HackleReactSDKClient.prototype.featureFlagDetail = function (featureKey, user) {
        return this.client.featureFlagDetail(featureKey, user || undefined);
    };
    HackleReactSDKClient.prototype.track = function (event, user) {
        this.client.track(event, user || undefined);
    };
    HackleReactSDKClient.prototype.trackPageView = function (option) {
        this.client.trackPageView(__assign(__assign({}, option), { user: (option === null || option === void 0 ? void 0 : option.user) || undefined }));
    };
    HackleReactSDKClient.prototype.remoteConfig = function (user) {
        return this.client.remoteConfig(user || undefined);
    };
    HackleReactSDKClient.prototype.onReady = function (cb, timeout) {
        this.client.onReady(cb, timeout);
    };
    HackleReactSDKClient.prototype.onInitialized = function (config) {
        return this.client.onInitialized(config);
    };
    HackleReactSDKClient.prototype.emitUpdatedUser = function (user) {
        if (!UserUtil.isUserEqual(this._currentUser, user)) {
            this.emit("user-updated", user);
        }
        this._currentUser = user;
    };
    HackleReactSDKClient.prototype.showUserExplorer = function () {
        this.client.showUserExplorer();
    };
    HackleReactSDKClient.prototype.hideUserExplorer = function () {
        this.client.hideUserExplorer();
    };
    HackleReactSDKClient.prototype.fetch = function () {
        return this.client.fetch();
    };
    return HackleReactSDKClient;
}(Emitter));
function createInstance(sdkKey, config) {
    return new HackleReactSDKClient(sdkKey, config);
}

var HackleContext = React.createContext({
    hackle: undefined,
    userVersion: 0,
    initialized: false
});
var HackleContextConsumer = HackleContext.Consumer;
var HackleContextProvider = HackleContext.Provider;

function HackleProvider(_a) {
    var hackleClient = _a.hackleClient, initialUser = _a.user, _b = _a.timeout, timeout = _b === void 0 ? 3000 : _b, _c = _a.supportSSR, supportSSR = _c === void 0 ? false : _c, children = _a.children;
    var _d = __read(React.useState({
        hackle: hackleClient,
        initialized: false,
        userVersion: 0
    }), 2), value = _d[0], setValue = _d[1];
    React.useEffect(function () {
        if (typeof initialUser !== "undefined" && initialUser !== null) {
            hackleClient.setUser(initialUser);
        }
    }, [initialUser]);
    React.useEffect(function () {
        var onUserUpdated = function () {
            setValue(function (prevState) { return (__assign(__assign({}, prevState), { userVersion: prevState.userVersion + 1 })); });
        };
        hackleClient.on("user-updated", onUserUpdated);
        return function () {
            hackleClient.off("user-updated", onUserUpdated);
        };
    }, [hackleClient]);
    React.useEffect(function () {
        hackleClient
            .onInitialized({ timeout: timeout })
            .then(function () {
            setValue(function (prevState) {
                return __assign(__assign({}, prevState), { initialized: true });
            });
        }, function () {
            setValue(function (prevState) {
                return __assign(__assign({}, prevState), { initialized: true });
            });
        })
            .catch(function () {
            setValue(function (prevState) {
                return __assign(__assign({}, prevState), { initialized: true });
            });
        });
    }, [hackleClient]);
    if (supportSSR) {
        return React__default["default"].createElement(HackleContextProvider, { value: value }, children);
    }
    return value.initialized ? React__default["default"].createElement(HackleContextProvider, { value: value }, children) : null;
}

var log = Hackle.Logger.log;
function useVariation(experimentKey, defaultVariation) {
    if (defaultVariation === void 0) { defaultVariation = "A"; }
    var _a = React.useContext(HackleContext), hackle = _a.hackle, userVersion = _a.userVersion, initialized = _a.initialized;
    var getVariation = React.useCallback(function () {
        return (initialized && (hackle === null || hackle === void 0 ? void 0 : hackle.variation(experimentKey))) || defaultVariation;
    }, [defaultVariation, experimentKey, hackle, initialized]);
    var _b = __read(React.useState(function () {
        if (notExistClient(hackle)) {
            if (typeof window !== "undefined") {
                log.error("HackleClient is not existed");
            }
            return defaultVariation;
        }
        return getVariation();
    }), 2), variation = _b[0], setVariation = _b[1];
    var currentInput = {
        key: experimentKey,
        userVersion: userVersion,
        initialized: initialized
    };
    var _c = __read(React.useState(currentInput), 2), prevInput = _c[0], setPrevInput = _c[1];
    if (!isInputEqual(prevInput, currentInput)) {
        setPrevInput(currentInput);
        setVariation(getVariation());
    }
    return variation;
}
function useVariationDetail(experimentKey, defaultVariation) {
    if (defaultVariation === void 0) { defaultVariation = "A"; }
    var _a = React.useContext(HackleContext), hackle = _a.hackle, userVersion = _a.userVersion, initialized = _a.initialized;
    var getVariationDetail = React.useCallback(function () {
        return (hackle === null || hackle === void 0 ? void 0 : hackle.variationDetail(experimentKey)) || Hackle.Decision.of(defaultVariation, Hackle.DecisionReason.EXCEPTION);
    }, [defaultVariation, experimentKey, hackle, initialized]);
    var _b = __read(React.useState(function () {
        if (notExistClient(hackle)) {
            if (typeof window !== "undefined") {
                log.error("HackleClient is not existed");
            }
            return Hackle.Decision.of(defaultVariation, Hackle.DecisionReason.EXCEPTION);
        }
        return getVariationDetail();
    }), 2), variationDetail = _b[0], setVariationDetail = _b[1];
    var currentInput = {
        key: experimentKey,
        userVersion: userVersion,
        initialized: initialized
    };
    var _c = __read(React.useState(currentInput), 2), prevInput = _c[0], setPrevInput = _c[1];
    if (!isInputEqual(prevInput, currentInput)) {
        setPrevInput(currentInput);
        setVariationDetail(getVariationDetail());
    }
    return variationDetail;
}
function useLoadableVariation(experimentKey, defaultVariation) {
    if (defaultVariation === void 0) { defaultVariation = "A"; }
    var _a = useLoadableVariationDetail(experimentKey, defaultVariation), isLoading = _a.isLoading, decision = _a.decision;
    return {
        isLoading: isLoading,
        variation: decision.variation
    };
}
function useLoadableVariationDetail(experimentKey, defaultVariation) {
    if (defaultVariation === void 0) { defaultVariation = "A"; }
    var _a = React.useContext(HackleContext), hackle = _a.hackle, userVersion = _a.userVersion, initialized = _a.initialized;
    var getVariationDetail = React.useCallback(function () {
        if (!initialized) {
            return Hackle.Decision.of(defaultVariation, Hackle.DecisionReason.SDK_NOT_READY);
        }
        return (hackle === null || hackle === void 0 ? void 0 : hackle.variationDetail(experimentKey)) || Hackle.Decision.of(defaultVariation, Hackle.DecisionReason.EXCEPTION);
    }, [defaultVariation, experimentKey, hackle, initialized]);
    var _b = __read(React.useState(function () {
        if (notExistClient(hackle)) {
            log.error("HackleClient is not existed");
            return Hackle.Decision.of(defaultVariation, Hackle.DecisionReason.EXCEPTION);
        }
        return getVariationDetail();
    }), 2), variationDetail = _b[0], setVariationDetail = _b[1];
    var currentInput = {
        key: experimentKey,
        userVersion: userVersion,
        initialized: initialized
    };
    var _c = __read(React.useState(currentInput), 2), prevInput = _c[0], setPrevInput = _c[1];
    if (!isInputEqual(prevInput, currentInput)) {
        setPrevInput(currentInput);
        setVariationDetail(getVariationDetail());
    }
    return {
        isLoading: !initialized,
        decision: variationDetail
    };
}
function useFeature(featureKey) {
    var _a = React.useContext(HackleContext), hackle = _a.hackle, userVersion = _a.userVersion, initialized = _a.initialized;
    var getIsOn = React.useCallback(function () {
        return (hackle === null || hackle === void 0 ? void 0 : hackle.isFeatureOn(featureKey)) || false;
    }, [featureKey, hackle, initialized]);
    var _b = __read(React.useState(function () {
        if (notExistClient(hackle)) {
            if (typeof window !== "undefined") {
                log.error("HackleClient is not existed");
            }
            return false;
        }
        return getIsOn();
    }), 2), isOn = _b[0], setIsOn = _b[1];
    var currentInput = {
        key: featureKey,
        userVersion: userVersion,
        initialized: initialized
    };
    var _c = __read(React.useState(currentInput), 2), prevInput = _c[0], setPrevInput = _c[1];
    if (!isInputEqual(prevInput, currentInput)) {
        setPrevInput(currentInput);
        setIsOn(getIsOn());
    }
    return isOn;
}
function useFeatureFlagDetail(featureKey) {
    var _a = React.useContext(HackleContext), hackle = _a.hackle, userVersion = _a.userVersion, initialized = _a.initialized;
    var getFeatureDetail = React.useCallback(function () {
        return (hackle === null || hackle === void 0 ? void 0 : hackle.featureFlagDetail(featureKey)) || Hackle.FeatureFlagDecision.off(Hackle.DecisionReason.EXCEPTION);
    }, [featureKey, hackle, initialized]);
    var _b = __read(React.useState(function () {
        if (notExistClient(hackle)) {
            if (typeof window !== "undefined") {
                log.error("HackleClient is not existed");
            }
            return Hackle.FeatureFlagDecision.off(Hackle.DecisionReason.EXCEPTION);
        }
        return getFeatureDetail();
    }), 2), featureDetail = _b[0], setFeatureDetail = _b[1];
    var currentInput = {
        key: featureKey,
        userVersion: userVersion,
        initialized: initialized
    };
    var _c = __read(React.useState(currentInput), 2), prevInput = _c[0], setPrevInput = _c[1];
    if (!isInputEqual(prevInput, currentInput)) {
        setPrevInput(currentInput);
        setFeatureDetail(getFeatureDetail());
    }
    return featureDetail;
}
function useLoadableFeature(featureKey) {
    var _a = useLoadableFeatureDetail(featureKey), isLoading = _a.isLoading, decision = _a.decision;
    return {
        isLoading: isLoading,
        isOn: decision.isOn
    };
}
function useLoadableFeatureDetail(featureKey) {
    var _a = React.useContext(HackleContext), hackle = _a.hackle, userVersion = _a.userVersion, initialized = _a.initialized;
    var getFeatureDetail = React.useCallback(function () {
        if (!initialized) {
            return Hackle.FeatureFlagDecision.off(Hackle.DecisionReason.SDK_NOT_READY);
        }
        return (hackle === null || hackle === void 0 ? void 0 : hackle.featureFlagDetail(featureKey)) || Hackle.FeatureFlagDecision.off(Hackle.DecisionReason.EXCEPTION);
    }, [featureKey, hackle, initialized]);
    var _b = __read(React.useState(function () {
        if (notExistClient(hackle)) {
            log.error("HackleClient is not existed");
            return Hackle.FeatureFlagDecision.off(Hackle.DecisionReason.EXCEPTION);
        }
        return getFeatureDetail();
    }), 2), featureDetail = _b[0], setFeatureDetail = _b[1];
    var currentInput = {
        key: featureKey,
        userVersion: userVersion,
        initialized: initialized
    };
    var _c = __read(React.useState(currentInput), 2), prevInput = _c[0], setPrevInput = _c[1];
    if (!isInputEqual(prevInput, currentInput)) {
        setPrevInput(currentInput);
        setFeatureDetail(getFeatureDetail());
    }
    return {
        isLoading: !initialized,
        decision: featureDetail
    };
}
function useRemoteConfig() {
    var _a = React.useContext(HackleContext), hackle = _a.hackle, userVersion = _a.userVersion, initialized = _a.initialized;
    var getRemoteConfig = React.useCallback(function () {
        return (hackle === null || hackle === void 0 ? void 0 : hackle.remoteConfig()) || new Hackle.EmptyHackleRemoteConfig();
    }, [hackle, initialized]);
    var _b = __read(React.useState(function () {
        if (notExistClient(hackle)) {
            log.error("HackleClient is not existed");
        }
        return getRemoteConfig();
    }), 2), remoteConfig = _b[0], setRemoteConfig = _b[1];
    var currentInput = {
        userVersion: userVersion,
        initialized: initialized
    };
    var _c = __read(React.useState(currentInput), 2), prevInput = _c[0], setPrevInput = _c[1];
    if (!isInputEqual(prevInput, currentInput)) {
        setPrevInput(currentInput);
        setRemoteConfig(getRemoteConfig());
    }
    return remoteConfig;
}
function useLoadableRemoteConfig() {
    var _a = React.useContext(HackleContext), hackle = _a.hackle, userVersion = _a.userVersion, initialized = _a.initialized;
    var getRemoteConfig = React.useCallback(function () {
        if (!initialized) {
            return new Hackle.EmptyHackleRemoteConfig();
        }
        return (hackle === null || hackle === void 0 ? void 0 : hackle.remoteConfig()) || new Hackle.EmptyHackleRemoteConfig();
    }, [hackle, initialized]);
    var _b = __read(React.useState(function () {
        if (notExistClient(hackle)) {
            log.error("HackleClient is not existed");
        }
        return getRemoteConfig();
    }), 2), remoteConfig = _b[0], setRemoteConfig = _b[1];
    var currentInput = {
        userVersion: userVersion,
        initialized: initialized
    };
    var _c = __read(React.useState(currentInput), 2), prevInput = _c[0], setPrevInput = _c[1];
    if (!isInputEqual(prevInput, currentInput)) {
        setPrevInput(currentInput);
        setRemoteConfig(getRemoteConfig());
    }
    return {
        isLoading: !initialized,
        remoteConfig: remoteConfig
    };
}
function useTrack() {
    var hackle = React.useContext(HackleContext).hackle;
    if (notExistClient(hackle)) {
        log.error("HackleClient is not existed");
        return function () { };
    }
    return function (event) { return hackle === null || hackle === void 0 ? void 0 : hackle.track(event); };
}
function notExistClient(hackle) {
    return !hackle;
}
function isInputEqual(prev, current) {
    return (prev.initialized === current.initialized && prev.key === current.key && prev.userVersion === current.userVersion);
}

function Experiment(_a) {
    var experimentKey = _a.experimentKey, children = _a.children;
    var _b = useLoadableVariation(experimentKey), isLoading = _b.isLoading, variation = _b.variation;
    if (isLoading) {
        return null;
    }
    if (!!children && typeof children === "function") {
        return children(variation);
    }
    var match;
    React__namespace.Children.forEach(children, (function (it) {
        if (!React__namespace.isValidElement(it)) {
            return;
        }
        if (it.props.variation) {
            if (variation === it.props.variation) {
                match = it;
            }
        }
        else if (it.props.default) {
            match = it;
        }
    }));
    return match ? React__namespace.cloneElement(match, { variation: variation }) : null;
}
var HackleExperiment = Experiment;

function Variation(_a) {
    _a.variation; var children = _a.children;
    return React__namespace.createElement(React__namespace.Fragment, null, children);
}
var HackleVariation = Variation;

var Feature = function (props) {
    var _a = useLoadableFeature(props.featureKey), isLoading = _a.isLoading, featureOn = _a.isOn;
    if (isLoading) {
        return null;
    }
    return React__default["default"].createElement(React__default["default"].Fragment, null, props.children(featureOn));
};
var HackleFeature = Feature;

exports.HackleContext = HackleContext;
exports.HackleContextConsumer = HackleContextConsumer;
exports.HackleContextProvider = HackleContextProvider;
exports.HackleExperiment = HackleExperiment;
exports.HackleFeature = HackleFeature;
exports.HackleProvider = HackleProvider;
exports.HackleVariation = HackleVariation;
exports.createInstance = createInstance;
exports.useFeature = useFeature;
exports.useFeatureFlagDetail = useFeatureFlagDetail;
exports.useLoadableFeature = useLoadableFeature;
exports.useLoadableFeatureDetail = useLoadableFeatureDetail;
exports.useLoadableRemoteConfig = useLoadableRemoteConfig;
exports.useLoadableVariation = useLoadableVariation;
exports.useLoadableVariationDetail = useLoadableVariationDetail;
exports.useRemoteConfig = useRemoteConfig;
exports.useTrack = useTrack;
exports.useVariation = useVariation;
exports.useVariationDetail = useVariationDetail;
Object.keys(Hackle).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return Hackle[k]; }
    });
});
